export default __webpack_public_path__ + "static/hyperedge-65edfa07694d65be8732c3dc07f3f854.png";